export default function (RestangularProvider) {
    RestangularProvider.addFullRequestInterceptor(function (element, operation, what, url, headers, params, httpConfig) {

        if (['patch', 'put'].indexOf(operation) !== -1)
            delete element.id;

        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['user', 'prenscriptor', 'company'].indexOf(what) !== -1) {

            if (element.workers) {
                element.workers = element.workers.map(function (obj) {
                    return obj.id;
                });
            }

            if (element.birthday) {
                let date = new Date(element.birthday);
                element.birthday = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }

            if (element.training_date) {
                let date = new Date(element.training_date);
                element.trainingDate = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }

            if (element.prescriber_type) {
                element.prescriberType = element.prescriber_type.id;
            }
            if (element.training_time) {
                element.trainingTime = element.training_time;
            }
            if (element.postal_code) {
                element.postalCode = element.postal_code;
            }

            if (element.prescriber && element.prescriber.id) {
                element.prescriber = element.prescriber.id;
            }

            if (element.company && element.company.id) {
                element.company = element.company.id;
            }
            if (element.roles) {
                element.roles = [element.roles];
            }

            delete element.company;
            delete element.training_date;
            delete element.patients;
            delete element.subscriptions;
            delete element.subscription;
            delete element.created;
            delete element.prescriber_type;
            delete element.training_time;
            delete element.licences;
            delete element.purchases;
            delete element.workers;
            delete element.postal_code;
            delete element.updated;
            delete element.points;

        }

        if(operation == 'post'){
            if(typeof element == 'object'){
                for(let i in element){

                    if(!element[i])
                        delete element[i];

                    else if(typeof element[i] == 'object' && element[i]['id'] && element[i]['id'] == 0)
                        delete element[i];
                }
            }
        }
        if (['post', 'patch'].indexOf(operation) !== -1 && ['event'].indexOf(what) !== -1) {
            if (element.date) {
                let date = new Date(element.date);
                element.date = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2) + " " + ("0" + (date.getHours())).slice(-2) +":"+ ("0" + (date.getMinutes())).slice(-2);
            }

            if (element.location_map) {
                element.locationMap = element.location_map;
            }

            delete element.location_map;
        }
        if (['post', 'put'].indexOf(operation) !== -1 && ['config', 'variable'].indexOf(what) !== -1) {

            if (element.hardness_initial) {
                let newValue = {};

                for (let i in element.hardness_initial) {
                    newValue[element.hardness_initial[i].key] = element.hardness_initial[i].value;
                }

                element.hardnessInitial = newValue;
            }

            if (element.modify_variable) {
                let newValue = {};

                for (let i in element.modify_variable) {
                    newValue[element.modify_variable[i].key] = element.modify_variable[i].value;
                }

                element.modifyVariable = newValue;
            }

            if (element.modify_relation) {
                let newValue = {};

                for (let i in element.modify_relation) {
                    newValue[element.modify_relation[i].key] = element.modify_relation[i].value;
                }

                element.modifyRelation = newValue;
            }

            if (element.modify_fixed) {
                element.modifyFixed = element.modify_fixed;
            }

            if (element.game) {
                element.game = element.game.id;
            }

            delete element.hardness_initial;
            delete element.modify_variable;
            delete element.modify_relation;
            delete element.modify_fixed;
        }

        if (['post', 'put'].indexOf(operation) !== -1 && ['prescriberType'].indexOf(what) !== -1) {
            delete element.prescribers;
        }

        if (['post', 'put'].indexOf(operation) !== -1 && ['game'].indexOf(what) !== -1) {
            if (element.ability) {
                element.ability = element.ability.id;
            }
        }

        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['purchase', 'licence', 'subscription', 'product', 'invoice', 'payment'].indexOf(what) !== -1) {
            if (element.created) {
                let date = new Date(element.created);
                element.created = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }
            if (element.updated) {
                let date = new Date(element.updated);
                element.updated = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }
            if (element.finalized) {
                let date = new Date(element.finalized);
                element.finalized = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }
            if (element.initialize) {
                let date = new Date(element.initialize);
                element.initialize = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
            }


            if('licence'.indexOf(what) !== -1)
                delete element.gamesvr;

            if (element.licence_type) {
                element.licenceType = element.licence_type;
                delete element.licence_type;
            }

            if (element.licences_type) {
                element.licencesType = element.licences_type;
                delete element.licences_type;
            }

            if (element.purchase_user) {
                element.purchaseUser = element.purchase_user.id;
                delete element.purchase_user;
            }

            delete element.invoice_data;
            delete element.internal;
        }

        if (['post', 'put', 'patch'].indexOf(operation) !== -1 && ['invoice', 'payment'].indexOf(what) !== -1) {
             if (element.product) {
                element.product = element.product.id;
             }
        }

        return {element: element};
    });

};



/** WEBPACK FOOTER **
 ** ./js/config/request_interceptor.js
 **/